export const appliedCoupons = `
  appliedCoupons {
    code
    discountAmount
    discountTax
  }
`;
